<template>
	<div class="tz-table">
		<el-table	:data="tongzhipage"	border>
			<el-table-column type="index" align="center" width="80" label="序号">
			</el-table-column>
			<el-table-column prop="bt" label="标题">
			  <template slot-scope="scope">
				<span :class="scope.row.tzFlag ? 'wd-txt':''">{{scope.row.bt}}</span>
			  </template>
			</el-table-column>
			<el-table-column align="center" width="180" label="更新时间">
			  <template slot-scope="scope">
				  {{formatDate(new Date(scope.row.gxsj),'yyyy-MM-dd hh:mm')}}
			  </template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="180">
			  <template slot-scope="scope">
				  <el-button type="text" @click="gotoDetail(scope.row.id)">查看</el-button>
			  </template>
			</el-table-column>
		</el-table>
		<el-pagination
		  class="page-zj"
		  @size-change="handleSizeChange"
		  @current-change="handleCurrentChange"
		  :current-page="page"
		  :page-sizes="[10, 20, 30, 40, 50]"
		  :page-size="size"
		  layout="total, sizes, prev, pager, next, jumper"
		  :total="total">
		</el-pagination>
	</div>
</template>

<script>
	export default{
		name: "tzList",
		data() {
		  return {
        tongzhipage: [],
        page: 1,
        size: 10,
        total: 0
		  }
		},
		mounted() {
			this.findTzPage();
		},
		methods: {
			findTzPage(){
				this.$post('admin/SysTzController/sysTzPage',{page: this.page-1,size: this.size,zt: 1}).then((arg) => {
					this.tongzhipage = arg.result.tzPage.content;
					this.total = arg.result.tzPage.totalElements;
				})
			},
			gotoDetail(tzid){
				var _this = this;
				/*setTimeout(function(){
					_this.findTzPage();
					_this.$emit('getNewtz');
				},1000);
				let page = _this.$router.resolve({path: '/tzDetail',query: {id: tzid}});
				window.open(page.href,'_blank');*/
        _this.$router.push({path: '/tzDetail',query: {id: tzid}})
			},
			handleSizeChange(val){
				this.size = val;
				this.findTzPage();
			},
			handleCurrentChange(val){
				this.page = val;
				this.findTzPage();
			}
		}
	}
</script>

<style lang="less">
	.tz-table{
		.el-table{
			width: 90%;
			margin: 0 auto;
			margin-top: 40px;
		}
		.page-zj{
			width: 90%;
			text-align: right;
			margin: 0 auto;
			margin-top: 20px;
		}
		.wd-txt{
			font-weight: bold;
			color: #333;
		}
	}
</style>